import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UI_GRAY = "#C0C0C0";
const DARK_GRAY = "#808080";
const LIGHT_GRAY = "#D0D0D0";
const BORDER_WHITE = "#FFFFFF";

const uiData = {
    companyInfo: {
        name: "JALARAM VEGETABLE CO. ■",
        description: "FRUIT - VEGETABLE MERCHANT AND COMMISSION AGENT",
        phone: "9824185221",
    },
    header: {
        title: "DEBIT/COLLECTION BILL LIST",
        date: new Date().toLocaleDateString(),
    },
    reportDetails: {
        reportLabel: "Report Date :",
        dateValue: new Date().toISOString().split("T")[0],
        day: new Date().toLocaleDateString("en-US", { weekday: "long" }),
    },
    filterOptions: {
        title: "SELECT BILL OPTIONS",
        radioGroups: [
            { id: "allRecords", label: "All Records" },
            { id: "onlySelected", label: "Only Selected" },
            { id: "byName", label: "By Name" },
            { id: "byCode", label: "By Code" },
            { id: "byArea", label: "By Area" },
        ],
        checkbox: {
            id: "goodsOnDate",
            label: "Only those with goods on the given date",
        },
    },
    tableHeaders: [
        { key: "accountName", label: "ACCOUNT NAME" },
        { key: "villageName", label: "VILLAGE NAME" },
    ],
    footer: {
        selectedCountLabel: "Total Selected :",
        selectedCount: 0,
        pageCountLabel: "Total Page Count :",
        pageCount: 0,
        buttons: [
            { label: "Select All" },
            { label: "Un Select All" },
            { label: "WhatsApp" },
            { label: "Print Bill" },
            { label: "Cancel" },
            { label: "Exit" },
        ],
    },
};

const LegacyButton = ({ children, onClick = () => { } }) => (
    <button
        onClick={onClick}
        style={{ backgroundColor: LIGHT_GRAY }}
        className="px-4 py-1 text-sm font-medium border border-black 
               shadow-[inset_-2px_-2px_0px_white,inset_2px_2px_0px_gray] 
               hover:brightness-105 
               active:shadow-[inset_2px_2px_0px_white,inset_-2px_-2px_0px_gray] 
               active:translate-y-[1px] transition-all"
    >
        {children}
    </button>
);

const App = () => {
    const navigate = useNavigate();

    const [selectedFilter, setSelectedFilter] = useState("allRecords");
    const [isGoodsOnDateChecked, setIsGoodsOnDateChecked] = useState(false);
    const [reportDate, setReportDate] = useState(uiData.reportDetails.dateValue);
    const [selectedRows, setSelectedRows] = useState([]);

    const handleSelectAll = () => {
        setSelectedRows(Array.from({ length: 15 }, (_, i) => i));
    };

    const handleUnselectAll = () => {
        setSelectedRows([]);
    };

    const handleCancel = () => {
        setSelectedFilter("allRecords");
        setIsGoodsOnDateChecked(false);
        setSelectedRows([]);
        setReportDate(uiData.reportDetails.dateValue);
    };

    const handleExit = () => {
        navigate("/dashboard");
    };

    return (
        <div
            style={{ backgroundColor: UI_GRAY }}
            className="h-screen w-screen flex justify-center items-center p-2 font-inter text-black overflow-hidden"
        >
            <div
                style={{ backgroundColor: UI_GRAY }}
                className="border border-black shadow-lg w-full h-full flex flex-col"
            >
                <div className="flex-grow grid grid-cols-1 md:grid-cols-3 gap-2 p-2 overflow-auto">

                    <div className="md:col-span-2 flex flex-col space-y-2">
                        <div style={{ backgroundColor: BORDER_WHITE }} className="p-2 border shadow-inner">
                            <p className="font-bold text-lg text-red-700">
                                ■ {uiData.companyInfo.name}
                            </p>
                            <p className="ml-4 text-xs">{uiData.companyInfo.description}</p>
                            <p className="ml-4 text-xs">Phone : {uiData.companyInfo.phone}</p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-2">
                            <div className="p-1 border border-black text-white bg-blue-700 flex items-center space-x-1 font-semibold text-sm">
                                <span>{uiData.reportDetails.reportLabel}</span>
                                <input
                                    type="date"
                                    value={reportDate}
                                    onChange={(e) => setReportDate(e.target.value)}
                                    className="bg-white text-blue-700 px-2 py-0.5 border border-blue-700 font-bold"
                                />
                            </div>
                            <div
                                style={{ backgroundColor: LIGHT_GRAY }}
                                className="p-1 border border-black text-black font-semibold text-sm flex items-center"
                            >
                                {new Date(reportDate).toLocaleDateString("en-US", { weekday: "long" })}
                            </div>
                        </div>

                        <div style={{ backgroundColor: BORDER_WHITE }} className="flex flex-col flex-grow border shadow-inner">
                            <div
                                style={{ backgroundColor: DARK_GRAY }}
                                className="flex border-b border-black text-white font-bold text-xs"
                            >
                                {uiData.tableHeaders.map((header) => (
                                    <div
                                        key={header.key}
                                        className="p-1 border-r border-black w-1/2 text-center"
                                    >
                                        {header.label}
                                    </div>
                                ))}
                            </div>
                            <div className="flex-grow grid grid-cols-2 text-black bg-white overflow-y-auto">
                                {Array.from({ length: 15 }).map((_, index) => (
                                    <React.Fragment key={index}>
                                        <div
                                            className={`h-6 border-b border-r border-gray-200 p-1 text-xs cursor-pointer ${selectedRows.includes(index) ? "bg-yellow-200" : ""
                                                }`}
                                            onClick={() =>
                                                setSelectedRows((prev) =>
                                                    prev.includes(index)
                                                        ? prev.filter((id) => id !== index)
                                                        : [...prev, index]
                                                )
                                            }
                                        >
                                            test {index + 1}
                                        </div>
                                        <div className="h-6 border-b border-gray-200 p-1 text-xs"></div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col space-y-2">
                        <div
                            style={{ backgroundColor: BORDER_WHITE }}
                            className="p-2 border shadow-inner text-center"
                        >
                            <p className="font-bold text-lg">{uiData.header.title}</p>
                            <p className="text-sm">Date : {reportDate}</p>
                        </div>

                        <div style={{ backgroundColor: BORDER_WHITE }} className="border flex-grow p-2 flex flex-col space-y-2">
                            <div className="text-white bg-green-600 text-center font-bold p-1 shadow-md text-sm">
                                {uiData.filterOptions.title}
                            </div>
                            <div className="flex flex-col space-y-2 pl-2">
                                {uiData.filterOptions.radioGroups.map((option) => (
                                    <label key={option.id} className="flex items-center space-x-2 cursor-pointer text-sm">
                                        <input
                                            type="radio"
                                            name="billFilter"
                                            value={option.id}
                                            checked={selectedFilter === option.id}
                                            onChange={(e) => setSelectedFilter(e.target.value)}
                                            className="h-4 w-4"
                                        />
                                        <span className={selectedFilter === option.id ? "font-bold" : ""}>
                                            {option.label}
                                        </span>
                                    </label>
                                ))}
                                <label className="flex items-center space-x-2 mt-2 cursor-pointer text-sm">
                                    <input
                                        type="checkbox"
                                        checked={isGoodsOnDateChecked}
                                        onChange={(e) => setIsGoodsOnDateChecked(e.target.checked)}
                                        className="h-4 w-4"
                                    />
                                    <span>{uiData.filterOptions.checkbox.label}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ backgroundColor: UI_GRAY }} className="flex flex-wrap justify-center gap-2 p-2 border-t">
                    {uiData.footer.buttons.map((btn) => {
                        if (btn.label === "Select All")
                            return <LegacyButton key={btn.label} onClick={handleSelectAll}>{btn.label}</LegacyButton>;
                        if (btn.label === "Un Select All")
                            return <LegacyButton key={btn.label} onClick={handleUnselectAll}>{btn.label}</LegacyButton>;
                        if (btn.label === "Cancel")
                            return <LegacyButton key={btn.label} onClick={handleCancel}>{btn.label}</LegacyButton>;
                        if (btn.label === "Exit")
                            return <LegacyButton key={btn.label} onClick={handleExit}>{btn.label}</LegacyButton>;
                        return <LegacyButton key={btn.label}>{btn.label}</LegacyButton>;
                    })}
                </div>
            </div>
        </div>
    );
};

export default App;
